module.exports = __webpack_public_path__ + "img/granada-logo-icon.0dd144a3.png";